import { View } from "binder"
import { selector, TypeEditorViewModel } from "./typeEditor-viewModel"

export class TypeEditorView extends View<TypeEditorViewModel>{
    GetViewUniqueId(): string {
        return "V-CF374E4B-757A-43C1-A4FE-5F6111B9B69A"
    }
    loadHtml(): string {
        let element = require('./typeEditor.html').default;
        let style = require('./typeEditor.less');
        return element;
    }
    constructor() {
       super();
    }
    public set selector(v: selector) { this._selector = v; } public get selector(): selector { return this._selector;} private _selector: selector;

}
